import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(public router: Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      let validation;
      try {
        const auth = localStorage.getItem('auth');
        if (auth && auth === '1') {
          console.log('in auth guard, condition pass')
          validation = false;
          this.router.navigateByUrl('/products');
        } else {
          throw new Error('Logged in');
        }
      } catch (error) {
        validation = true;
      }
      return validation;
  }
  
}
